import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { Astre, Astres } from '../../_enums/astre';
import { Legion, Legions } from '../../_enums/legion';
import { Personnage } from '../../_models/personnage';
import { CharacterSheetService } from '../../_services/character-sheet.service';
import { Router } from '@angular/router';
import { TypeDeSorts } from '../../_enums/typeDeSort';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/_services/admin.service';
import { Competence } from 'src/app/_models/competence';
import { Sort } from 'src/app/_models/sort';
import { CompetenceService } from 'src/app/_services/competence.service';
import { SortService } from 'src/app/_services/sort.service';
import { CompetencePersonnage } from 'src/app/_models/competencePersonnage';
import { AdminPersonnageRemoveSortCommand } from 'src/app/_models/_commands/admin/adminPersonnageCommands';

@Component({
  selector: 'app-admin',
  templateUrl: './fichePersonnage.component.html',
  styleUrls: ['./fichePersonnage.component.scss']
})
export class AdminFichePersonnageComponent implements OnInit {

    personnage!: Personnage;
    characterSheetForm!: FormGroup;
    addCompetenceForm!: FormGroup;
    addSortForm!: FormGroup;
    submitted: boolean = false;
  
    public legions = new Legions;
    public astres = new Astres;
    sorts!: Sort[];
    competences!: Competence[];
    
    constructor(private formBuilder: FormBuilder, private competenceService: CompetenceService, private sortService: SortService, private route: ActivatedRoute, private router: Router, private toastrs: ToastrService, private adminService: AdminService) {
     }

  ngOnInit(): void {
    var personnageId = 0;
    this.route.params.pipe(first()).subscribe(params => {
        personnageId = params['characterSheetId'];
      });
    
    if (personnageId != 0)
    {
      this.adminService.getPersonnage(personnageId)          
      .pipe(first())
      .subscribe({
        next: (personnage) => 
        {
          this.personnage = personnage;
          this.initializePersonnageForm();
        },
        error: (e) => 
        {
          console.error(e);
          this.router.navigate(['/admin/listeFichePersonnage']);
        }
      });
    }
    else
    {
      this.router.navigate(['/admin/listeFichePersonnage']);
    }
    
    this.competenceService.getCompetences()          
    .pipe(first())
    .subscribe({
      next: (competences) => 
      {
        this.competences = competences;
      }
    });
    
    this.sortService.getSorts()
    .pipe(first())
    .subscribe({
      next: (sorts) => {
        this.sorts = sorts;
      }
    });
  }

  initializePersonnageForm() {
    this.addCompetenceForm = this.formBuilder.group({
      addedCompetenceNiveau:['1', Validators.required],
      addedCompetenceId: ['', Validators.required],
    });
    this.addSortForm = this.formBuilder.group({
      addedSortId:['', Validators.required],
    });
    this.characterSheetForm = this.formBuilder.group({
      Nom: [this.personnage?.nom],
      Legion: [this.personnage?.legion],
      Astre1: [this.personnage?.astre1],
      Astre2: [this.personnage?.astre2],
      NotePublic: [this.personnage?.notePublic],
      CrimsonDisponible: [this.personnage?.crimsonDisponible],
      AchatDisponible: [this.personnage?.achatDisponible],
      AchatSortDisponible: [this.personnage?.achatSortDisponible],
      AchatSortAchete: [this.personnage?.achatSortAchete],
      NombreGnParticipe: [this.personnage?.nombreGnParticipe],
      BackgroundPersonnalite: [this.personnage?.background?.personnalite],
      BackgroundConcept: [this.personnage?.background?.concept],
      BackgroundHistorique: [this.personnage?.background?.historique],
      BackgroundButCourtTerme: [this.personnage?.background?.butCourtTerme],
      BackgroundButMoyenTerme: [this.personnage?.background?.butMoyenTerme],
      BackgroundButLongTerme: [this.personnage?.background?.butLongTerme],
    });
  }

  getCompetence(competenceId: number): Competence | null {
    if (this.competences)
     return this.competences.filter(c => c.id == competenceId)[0];
    else
      return null;
  }

  getSortsPersonnage() {
    return this.sorts.filter((s) => this.personnage.sorts.find((ps) => ps.sortId == s.id) != null);
  }

  changePersonnage() {
    this.adminService.changeInfo({
      commandId: crypto.randomUUID(),
      personnageId: this.personnage.id,
      Nom: this.characterSheetForm.controls['Nom'].value,
      NotePublic: this.characterSheetForm.controls['NotePublic'].value,
      CrimsonDisponible: this.characterSheetForm.controls['CrimsonDisponible'].value,
      AchatDisponible: this.characterSheetForm.controls['AchatDisponible'].value,
      AchatSortDisponible: this.characterSheetForm.controls['AchatSortDisponible'].value,
      AchatSortAchete: this.characterSheetForm.controls['AchatSortAchete'].value,
      NombreGnParticipe: this.characterSheetForm.controls['NombreGnParticipe'].value,
      Legion: this.characterSheetForm.controls['Legion'].value,
      Astre1: this.characterSheetForm.controls['Astre1'].value,
      Astre2: this.characterSheetForm.controls['Astre2'].value,
      BackgroundPersonnalite: this.characterSheetForm.controls['BackgroundPersonnalite'].value,
      BackgroundConcept: this.characterSheetForm.controls['BackgroundConcept'].value,
      BackgroundHistorique: this.characterSheetForm.controls['BackgroundHistorique'].value,
      BackgroundButCourtTerme: this.characterSheetForm.controls['BackgroundButCourtTerme'].value,
      BackgroundButMoyenTerme: this.characterSheetForm.controls['BackgroundButMoyenTerme'].value,
      BackgroundButLongTerme: this.characterSheetForm.controls['BackgroundButLongTerme'].value,
    })
    .pipe(first())
    .subscribe({
      next: (result) => {
        location.reload()
      }
    });
  }

  addCompetence() {
    this.adminService.addCompetence({
      commandId: crypto.randomUUID(),
      personnageId: this.personnage.id,
      Niveau: this.addCompetenceForm.controls['addedCompetenceNiveau'].value,
      CompetenceId: this.addCompetenceForm.controls['addedCompetenceId'].value,
    })
    .pipe(first())
    .subscribe({
      next: (result) => {
        location.reload()
      }
    });
  }

  removeCompetence(competencePersonnage: CompetencePersonnage) {
    this.adminService.removeCompetence({
      commandId: crypto.randomUUID(),
      personnageId: this.personnage.id,
      CompetenceId: competencePersonnage.competenceId
    })
    .pipe(first())
    .subscribe({
      next: (result) => {
        location.reload()
      }
    });
  }

  addSort() {
    this.adminService.addSort({
      commandId: crypto.randomUUID(),
      personnageId: this.personnage.id,
      SortId: this.addSortForm.controls['addedSortId'].value,
    })
    .pipe(first())
    .subscribe({
      next: (result) => {
        location.reload()
      }
    });
  }

  removeSort(sort: Sort) {
    this.adminService.removeSort({
      commandId: crypto.randomUUID(),
      personnageId: this.personnage.id,
      SortId: sort.id
    })
    .pipe(first())
    .subscribe({
      next: (result) => {
        location.reload()
      }
    });
  }

  deletePersonnage() {
    this.adminService.deletePersonnage({
      commandId: crypto.randomUUID(),
      personnageId: this.personnage.id,
    })
    .pipe(first())
    .subscribe({
      next: (result) => {
        this.router.navigateByUrl(`/admin/listeFichePersonnage`);
      }
    });
  }
}
